import { render } from "./ReTokens.vue?vue&type=template&id=772e9e4a&scoped=true"
import script from "./ReTokens.vue?vue&type=script&lang=js"
export * from "./ReTokens.vue?vue&type=script&lang=js"

import "./ReTokens.vue?vue&type=style&index=0&id=772e9e4a&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772e9e4a"]])

export default __exports__